import {Link} from '@github-ui/react-core/link'
import {Blankslate, type Column, DataTable, Stack, Table} from '@primer/react/experimental'
import {useEffect, useState} from 'react'

import type {DashboardIssue} from '../data-types'

const columns: Array<Column<DashboardIssue>> = [
  {
    header: 'Title',
    field: 'title',
    renderCell: ({url, title}) => {
      return <Link to={url}>{title}</Link>
    },
  },
  {
    header: 'State',
    field: 'state',
  },
]

export function IssueTable({
  issues,
  isPending,
  isError,
  onRetry,
}: {
  issues: DashboardIssue[]
  isPending?: boolean
  isError?: boolean
  onRetry?: () => void
}) {
  const [isDismissed, setIsDismissed] = useState(false)
  // Reset dismissal state so we can show the error dialog again there's a new error
  useEffect(() => {
    if (!isError) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsDismissed(false)
    }
  }, [isError])

  return (
    <Stack data-testid="issue-table">
      {!isPending && !isError && issues.length === 0 ? (
        <Blankslate>No items to display</Blankslate>
      ) : (
        <Table.Container>
          {isPending || isError ? (
            <Table.Skeleton aria-label="Loading Issues" rows={10} columns={columns} />
          ) : (
            <DataTable aria-label="Issues" data={issues} columns={columns} />
          )}
          {isError && !isDismissed ? (
            <Table.ErrorDialog
              onDismiss={() => {
                setIsDismissed(true)
              }}
              onRetry={() => {
                onRetry?.()
              }}
            >
              There was a problem loading issues
            </Table.ErrorDialog>
          ) : null}
        </Table.Container>
      )}
    </Stack>
  )
}

try{ IssueTable.displayName ||= 'IssueTable' } catch {}